<template>
  <div class="w-full overflow-y-auto">
    <UiFormField name="destinationCount">
      <UiFormItem>
        <div class="flex items-center">
          <UiFormLabel class="flex-grow text-base font-medium">
            Destinations
          </UiFormLabel>
        </div>
        <div
          v-if="!auth.isUltra"
          class="relative p-2 flex justify-center align-center mb-4 overflow-hidden rounded-sm text-ultra w-full rounded-xl border-0 border-ultra ring ring-green-300/10 cursor-pointer text-sm"
          @click.stop.prevent="
            () => {
              $track('ultra_upsell_clicked', {
                value: 'obsplugin-golive',
              });
              openBrowserTo(urlToUltra);
            }
          "
        >
          <IconUltra class="h-8 w-8 mr-4" />
          <span>
            Unlock unlimited multistreaming with Ultra and grow your audience
            faster
            <Icon size="1em" name="lucide:arrow-right" />
          </span>
        </div>
        <DestinationList class="w-full" variant="goLive" />
        <UiFormMessage />
      </UiFormItem>
    </UiFormField>
    <Button class="w-full" variant="neutral" @click="handleAddDestination">
      <Icon name="lucide:plus" class="mr-2 h-4 w-4 opacity-70" />
      <span>Add Destination</span>
      <span v-if="!auth.isUltra" class="flex m-1 align-center">
        with <span class="text-ultra ml-1">Ultra</span
        ><IconUltra class="relative h-4 w-4 ml-1 top-1"
      /></span>
    </Button>
  </div>
</template>

<script setup lang="ts">
import { openBrowserTo } from '~/lib/bindings';
import { getUltraUrl } from '~/lib/ultra';

const auth = useAuthStore();
const { track: $track } = useTrackingStore();
const urlToUltra = getUltraUrl({ refl: 'obsplugin-golive' }, true);
const emit = defineEmits(['cancel']);

const handleAddDestination = () => {
  emit('cancel');
  navigateTo('/multistream');
};
</script>
